import Swiper, { Navigation, Pagination } from "swiper";

[...document.querySelectorAll('[data-behaviour="carousel"]')].map((section) => {
    const slider = section.querySelector("[data-carousel-element]");
    const variant = section.dataset.carouselVariant;
    const nextEl = section.querySelector('[data-behaviour="carousel-next"]');
    const prevEl = section.querySelector(
        '[data-behaviour="carousel-previous"]'
    );
    const paginationEl = section.querySelector(
        '[data-behaviour="carousel-pagination"]'
    );
    let options = {
        direction: "horizontal",
        loop: false,
        grabCursor: true,
        spaceBetween: 32,
        modules: [Navigation, Pagination],
        navigation: nextEl && prevEl ? { nextEl, prevEl } : false,
        pagination: paginationEl
            ? {
                  el: paginationEl,
                  type: "fraction",
              }
            : false,
    };

    switch (variant) {
        case "case-study":
            options = {
                ...options,
                slidesPerView: 1.1,
                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1080: {
                        slidesPerView: 3,
                    },
                },
            };
            break;

        case "career":
            options = {
                ...options,
                slidesPerView: 3,
                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },
                    1080: {
                        slidesPerView: 2,
                    },
                },
            };
            break;

        case "quote":
            options = {
                ...options,
                slidesPerView: 1.1,
                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2.2,
                    },
                },
            };
            break;

        case "related":
            options = {
                ...options,
                slidesPerView: 1.1,
                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1080: {
                        slidesPerView: 3,
                    },
                },
            };
            break;

        case "noquote":
            options = {
                ...options,
                slidesPerView: 1.1,
                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },
                    500: {
                        slidesPerView: 3.1,
                    },
                    768: {
                        slidesPerView: 4.2,
                    },
                    1080: {
                        slidesPerView: 5,
                    },
                },
            };
            break;

        case "testimonial":
            options = {
                ...options,
                autoHeight: true,
                slidesPerView: 1.1,
                spaceBetween: 20,
                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2.2,
                        spaceBetween: 32,
                    },
                },
            };
            break;

        case "resources":
            options = {
                ...options,
                slidesPerView: 4,
                spaceBetween: 24,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    1080: {
                        slidesPerView: 4,
                    },
                },
            };
            break;
    }

    return new Swiper(slider, options);
});
